import { render, staticRenderFns } from "./batch-filter-candidate.vue?vue&type=template&id=65fdb537&scoped=true"
import script from "./batch-filter-candidate.vue?vue&type=script&lang=ts"
export * from "./batch-filter-candidate.vue?vue&type=script&lang=ts"
import style0 from "./batch-filter-candidate.vue?vue&type=style&index=0&id=65fdb537&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fdb537",
  null
  
)

export default component.exports